<template>
    <div class="card">
        <div class="card-header bg-gray">
            <h3 class="card-title"><i class="fas fa-list mr-2"></i>{{ $t('general.adjuntos') }}</h3>
        </div>
        <div class="card-body">
            <TabView ref="tabview" :scrollable="true">
                <TabPanel header="Servicio">
                    <h4 style="text-align:center">{{ $t('general.adjuntararchivosencorreo') }}</h4>
                    <div class="row">
                        <div class="col-sm-3" v-for="archivos in documentosservicio" :key="archivos">
                            <div v-if="archivos.visitadores_idvisitador == 0 && archivos.mensajes_id_mensaje == 0">


                                <div
                                    v-if="archivos.documento.substr(archivos.documento.length - 3) == 'jpg' || archivos.documento.substr(archivos.documento.length - 3) == 'png' || archivos.documento.substr(archivos.documento.length - 4) == 'jpeg' || archivos.documento.substr(archivos.documento.length - 3) == 'bmp' || archivos.documento.substr(archivos.documento.length - 3) == 'gif' || archivos.documento.substr(archivos.documento.length - 4) == 'tiff' || archivos.documento.substr(archivos.documento.length - 4) == 'webp'">

                                    <Image v-if="urlglobal != 'null.pwgs.app'" :src='archivos.url_completa_descarga'
                                        :id="archivos.id_documento" width="100" height="100" preview
                                        :alt="archivos.descripcion" />
                                    <Image v-if="urlglobal == 'null.pwgs.app'"
                                        :src='"https://desarrollofront.pwgs.app/documentos.php?documento=" + archivos.documento + "&servicio=" + id'
                                        :id="archivos.id_documento" width="100" height="100" preview
                                        :alt="archivos.descripcion" />
                                    <!--- <div v-if="parametros.campos_obligatorios.antes_despues == 1 && archivos.cuando==''"
                                    style="text-align: center;">
                                    <select v-model="archivos.cuando" id="tiempo">
                                        <option value="">Selecciona tiempo</option>
                                        <option value="Antes">Antes</option>
                                        <option value="Despues">Después</option>
                                    </select>
                                </div>
                                <div v-else style="text-align: center;">
                                    <span style="margin-right: 28%;" v-if="archivos.cuando=='despues'"
                                        class="badge bg-blue">después</span>
                                    <span style="margin-right: 28%;" v-else class="badge bg-blue">{{archivos.cuando
                                        }}</span>
                                </div>-->
                                </div>
                                <div v-if="archivos.documento.substr(archivos.documento.length - 3) == 'mp4'">
                                                                    <a target="_blank" :href="archivos.url_completa_descarga">Descargar video</a>

                                    <i class="fas fa-file-video" @click="mostrarVideo = !mostrarVideo"
                                        style="font-size:100px;color:#007bff;cursor:pointer"></i>
                                    <Dialog dismissableMask modal v-model:visible="mostrarVideo">
                                        <video width="100%" height="100%" :key="archivos.url_completa_descarga"
                                            controls>
                                            <source :src="archivos.url_completa_descarga" type="video/mp4">
                                        </video>
                                    </Dialog>


                                </div>
                                <div style="text-align: center;"
                                    v-if="archivos.documento.substr(archivos.documento.length - 3) != 'jpg' && archivos.documento.substr(archivos.documento.length - 3) != 'png' && archivos.documento.substr(archivos.documento.length - 4) != 'jpeg' && archivos.documento.substr(archivos.documento.length - 3) != 'bmp' && archivos.documento.substr(archivos.documento.length - 3) != 'gif' && archivos.documento.substr(archivos.documento.length - 4) != 'tiff' && archivos.documento.substr(archivos.documento.length - 4) != 'webp' && archivos.documento.substr(archivos.documento.length - 3) != 'mp4'">
                                    <a v-if="urlglobal != 'null.pwgs.app'" @click="descargarArchivos(archivos.url_completa_descarga)"
                                        :title="archivos.descripcion">
                                        <i class="fas fa-file-pdf" style="font-size:100px;"></i>
                                    </a>
                                    <a v-if="urlglobal == 'null.pwgs.app'"
                                        @click="descargarArchivos(archivos.url_completa_descarga)"
                                        :title="archivos.descripcion">
                                        <i class="fas fa-file-pdf" style="font-size:100px;"></i>
                                    </a>
                                </div>
                                <div :title="archivos.documento" class="row">
                                    <!--  <div class="col-md-3">-->&nbsp;&nbsp;&nbsp;
                                    <i title="Eliminar archivo" class="fas fa-times"
                                        style="color:red;cursor:pointer;margin-top:4px"
                                        @click="eliminararchivo(archivos.id_documento)"></i>&nbsp;
                                    &nbsp;
                                    <input :id="archivos.id_documento"
                                        @click="archivos.checked = !archivos.checked; adjuntararchivo(archivos, archivos.checked, archivos.id_documento)"
                                        v-model="archivos.checked" type="checkbox">
                                    <span
                                        v-if="parametros.campos_obligatorios.antes_despues == 1 && archivos.cuando == ''"
                                        style="text-align: center;padding-left: 16%">
                                        <select v-model="archivos.cuando" id="tiempo">
                                            <option value="">Selecciona tiempo</option>
                                            <option value="Antes">Antes</option>
                                            <option value="Despues">Después</option>
                                        </select>
                                    </span>
                                    <span v-else style="text-align: center;padding-left: 16%">
                                        <span style="margin-right: 28%;" v-if="archivos.cuando == 'despues'"
                                            class="badge bg-blue">después</span>
                                        <span style="margin-right: 28%;" v-else class="badge bg-blue">{{ archivos.cuando
                                            }}</span>
                                    </span>
                                    <span style="font-size: x-small;padding-left: 20%;">{{ archivos.fecha }}</span>

                                    <!-- </div>-->
                                    <!-- <div class="col-md-9">-->
                                    <!--   <label v-if="archivos.documento.valueOf().length>15" :for="archivos.id_documento">
                                        {{ archivos.documento.substring(0,15)+'...' }} </label>-->
                                    <label style="font-size: 12px;line-break: anywhere;  padding-right: 12px;"
                                        :for="archivos.id_documento">
                                        {{ archivos.documento }} </label>
                                    <p></p>
                                    <span v-if="archivos.descripcion" class="badge bg-secondary">{{ archivos.descripcion
                                        }}</span>

                                    <!--  </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <h4 style="text-align:center">{{ $t('general.subirarchivos') }}</h4>
                    <FileUpload ref="fileupuno" mode="advanced" :showUploadButton="false" :maxFileSize="20000000"
                        @select="subirarchivo($event)" multiple="true" chooseLabel="Elegir Archivos" />
                    <p></p>
                    <div class="row">
                        <div class="col-md-12">
                            <textarea placeholder="Descripcion del fichero" v-model="descrfichero" rows="5"
                                class="form-control"></textarea>
                        </div>
                    </div>
                    <p></p>
                    <div class="row">
                        <div class="col-md-12">
                            <button @click="uploadFile(0, 0,'visita')" class="btn btn-success btn-block"
                                type="button">{{
                                $t('general.subirarchivos') }}</button>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="Comunicaciones">
                    <h4 style="text-align:center">{{ $t('general.adjuntararchivosencorreo') }}</h4>
                    <div class="row">
                        <div class="col-sm-3" v-for="archivos in documentoscomunicaciones" :key="archivos">
                            <div v-if="archivos.mensajes_id_mensaje > 0">
                                <div
                                    v-if="archivos.documento.substr(archivos.documento.length - 3) == 'jpg' || archivos.documento.substr(archivos.documento.length - 3) == 'png' || archivos.documento.substr(archivos.documento.length - 4) == 'jpeg' || archivos.documento.substr(archivos.documento.length - 3) == 'bmp' || archivos.documento.substr(archivos.documento.length - 3) == 'gif' || archivos.documento.substr(archivos.documento.length - 4) == 'tiff' || archivos.documento.substr(archivos.documento.length - 4) == 'webp'">

                                    <Image v-if="urlglobal != 'null.pwgs.app'" :src='archivos.url_completa_descarga'
                                        :id="archivos.id_documento" width="100" height="100" preview
                                        :alt="archivos.descripcion" />
                                    <Image v-if="urlglobal == 'null.pwgs.app'"
                                        :src='"https://desarrollofront.pwgs.app/documentos.php?documento=" + archivos.documento + "&servicio=" + id'
                                        :id="archivos.id_documento" width="100" height="100" preview
                                        :alt="archivos.descripcion" />
                                    <!--- <div v-if="parametros.campos_obligatorios.antes_despues == 1 && archivos.cuando==''"
                                    style="text-align: center;">
                                    <select v-model="archivos.cuando" id="tiempo">
                                        <option value="">Selecciona tiempo</option>
                                        <option value="Antes">Antes</option>
                                        <option value="Despues">Después</option>
                                    </select>
                                </div>
                                <div v-else style="text-align: center;">
                                    <span style="margin-right: 28%;" v-if="archivos.cuando=='despues'"
                                        class="badge bg-blue">después</span>
                                    <span style="margin-right: 28%;" v-else class="badge bg-blue">{{archivos.cuando
                                        }}</span>
                                </div>-->
                                </div>
                                <div v-if="archivos.documento.substr(archivos.documento.length - 3) == 'mp4'">
                                                                    <a target="_blank" :href="archivos.url_completa_descarga">Descargar video</a>

                                    <i class="fas fa-file-video" @click="mostrarVideo = !mostrarVideo"
                                        style="font-size:100px;color:#007bff;cursor:pointer"></i>
                                    <Dialog dismissableMask modal v-model:visible="mostrarVideo">
                                        <video width="100%" height="100%" :key="archivos.url_completa_descarga"
                                            controls>
                                            <source :src="archivos.url_completa_descarga" type="video/mp4">
                                        </video>
                                    </Dialog>


                                </div>
                                <div style="text-align: center;"
                                    v-if="archivos.documento.substr(archivos.documento.length - 3) != 'jpg' && archivos.documento.substr(archivos.documento.length - 3) != 'png' && archivos.documento.substr(archivos.documento.length - 4) != 'jpeg' && archivos.documento.substr(archivos.documento.length - 3) != 'bmp' && archivos.documento.substr(archivos.documento.length - 3) != 'gif' && archivos.documento.substr(archivos.documento.length - 4) != 'tiff' && archivos.documento.substr(archivos.documento.length - 4) != 'webp' && archivos.documento.substr(archivos.documento.length - 3) != 'mp4'">
                                    <a v-if="urlglobal != 'null.pwgs.app'" @click="descargarArchivos(archivos.url_completa_descarga)"
                                        :title="archivos.descripcion">
                                        <i class="fas fa-file-pdf" style="font-size:100px;"></i>
                                    </a>
                                    <a v-if="urlglobal == 'null.pwgs.app'"
                                        @click="descargarArchivos(archivos.url_completa_descarga)"
                                        :title="archivos.descripcion">
                                        <i class="fas fa-file-pdf" style="font-size:100px;"></i>
                                    </a>
                                </div>
                                <div :title="archivos.documento" class="row">
                                    <!--  <div class="col-md-3">-->&nbsp;&nbsp;&nbsp;
                                    <i title="Eliminar archivo" class="fas fa-times"
                                        style="color:red;cursor:pointer;margin-top:4px"
                                        @click="eliminararchivo(archivos.id_documento)"></i>&nbsp;
                                    &nbsp;
                                    <input :id="archivos.id_documento"
                                        @click="archivos.checked = !archivos.checked; adjuntararchivo(archivos, archivos.checked, archivos.id_documento)"
                                        v-model="archivos.checked" type="checkbox">
                                    <span
                                        v-if="parametros.campos_obligatorios.antes_despues == 1 && archivos.cuando == ''"
                                        style="text-align: center;padding-left: 16%">
                                        <select v-model="archivos.cuando" id="tiempo">
                                            <option value="">Selecciona tiempo</option>
                                            <option value="Antes">Antes</option>
                                            <option value="Despues">Después</option>
                                        </select>
                                    </span>
                                    <span v-else style="text-align: center;padding-left: 16%">
                                        <span style="margin-right: 28%;" v-if="archivos.cuando == 'despues'"
                                            class="badge bg-blue">después</span>
                                        <span style="margin-right: 28%;" v-else class="badge bg-blue">{{ archivos.cuando
                                            }}</span>
                                    </span>
                                    <span style="font-size: x-small;padding-left: 20%;">{{ archivos.fecha }}</span>

                                    <!-- </div>-->
                                    <!-- <div class="col-md-9">-->
                                    <!--   <label v-if="archivos.documento.valueOf().length>15" :for="archivos.id_documento">
                                        {{ archivos.documento.substring(0,15)+'...' }} </label>-->
                                    <label style="font-size: 12px;line-break: anywhere;  padding-right: 12px;"
                                        :for="archivos.id_documento">
                                        {{ archivos.documento }} </label>
                                    <p></p>
                                    <span v-if="archivos.descripcion" class="badge bg-secondary">{{ archivos.descripcion
                                        }}</span>

                                    <!--  </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel v-for="visita in visitas" :key="visita"
                    :header="new Date(visita.visita.fecha).toLocaleDateString() + ' ' + visita.visita.hora.slice(0, -3) + ' - ' + visita.visita.nombre_operario">
                    <h4 style="text-align:center">{{ $t('general.adjuntararchivosencorreo') }}</h4>
                    <div class="row">
                        <div class="col-sm-3" v-for="archivos in visita.archivos" :key="archivos" @click="console.log('arcv', archivos.checked)">

                            <!---->
                            <div
                                v-if="archivos.documento.substr(archivos.documento.length - 3) == 'jpg' || archivos.documento.substr(archivos.documento.length - 3) == 'png' || archivos.documento.substr(archivos.documento.length - 4) == 'jpeg' || archivos.documento.substr(archivos.documento.length - 3) == 'bmp' || archivos.documento.substr(archivos.documento.length - 3) == 'gif' || archivos.documento.substr(archivos.documento.length - 4) == 'tiff' || archivos.documento.substr(archivos.documento.length - 4) == 'webp'">

                                <Image v-if="urlglobal != 'null.pwgs.app'" :src='archivos.url_completa_descarga'
                                    :id="archivos.id_documento" width="100" height="100" preview
                                    :alt="archivos.descripcion" />
                                <Image v-if="urlglobal == 'null.pwgs.app'"
                                    :src='"https://desarrollofront.pwgs.app/documentos.php?documento=" + archivos.documento + "&servicio=" +id '
                                    :id="archivos.id_documento" width="100" height="100" preview
                                    :alt="archivos.descripcion" />
                                <!--- <div v-if="parametros.campos_obligatorios.antes_despues == 1 && archivos.cuando==''"
                                    style="text-align: center;">
                                    <select v-model="archivos.cuando" id="tiempo">
                                        <option value="">Selecciona tiempo</option>
                                        <option value="Antes">Antes</option>
                                        <option value="Despues">Después</option>
                                    </select>
                                </div>
                                <div v-else style="text-align: center;">
                                    <span style="margin-right: 28%;" v-if="archivos.cuando=='despues'"
                                        class="badge bg-blue">después</span>
                                    <span style="margin-right: 28%;" v-else class="badge bg-blue">{{archivos.cuando
                                        }}</span>
                                </div>-->
                            </div>
                            <div v-if="archivos.documento.substr(archivos.documento.length - 3) == 'mp4'">
                                <a target="_blank" :href="archivos.url_completa_descarga">Descargar video</a>
                                <i class="fas fa-file-video" @click="mostrarVideo = !mostrarVideo"
                                    style="font-size:100px;color:#007bff;cursor:pointer"></i>
                                <Dialog dismissableMask modal v-model:visible="mostrarVideo">
                                    <video width="100%" height="100%" :key="archivos.url_completa_descarga" controls>
                                        <source :src="archivos.url_completa_descarga" type="video/mp4">
                                    </video>
                                </Dialog>


                            </div>
                            <div style="text-align: center;"
                                v-if="archivos.documento.substr(archivos.documento.length - 3) != 'jpg' && archivos.documento.substr(archivos.documento.length - 3) != 'png' && archivos.documento.substr(archivos.documento.length - 4) != 'jpeg' && archivos.documento.substr(archivos.documento.length - 3) != 'bmp' && archivos.documento.substr(archivos.documento.length - 3) != 'gif' && archivos.documento.substr(archivos.documento.length - 4) != 'tiff' && archivos.documento.substr(archivos.documento.length - 4) != 'webp' && archivos.documento.substr(archivos.documento.length - 3) != 'mp4'">
                                <a v-if="urlglobal != 'null.pwgs.app'" @click="descargarArchivos(archivos.url_completa_descarga)"
                                    :title="archivos.descripcion">
                                    <i class="fas fa-file-pdf" style="font-size:100px;"></i>
                                </a>
                                <a v-if="urlglobal == 'null.pwgs.app'"
                                    @click="descargarArchivos(archivos.url_completa_descarga)"
                                    :title="archivos.descripcion">
                                    <i class="fas fa-file-pdf" style="font-size:100px;"></i>
                                </a>
                            </div>
                            <div :title="archivos.documento" class="row">
                                <!--  <div class="col-md-3">-->&nbsp;&nbsp;&nbsp;
                                <i title="Eliminar archivo" class="fas fa-times"
                                    style="color:red;cursor:pointer;margin-top:4px"
                                    @click="eliminararchivo(archivos.id_documento)"></i>&nbsp;
                                &nbsp;
                                <input type="checkbox" :id="archivos.id_documento" @click="console.log(archivos.checked);archivos.checked = !archivos.checked; adjuntararchivo(archivos, archivos.checked, archivos.id_documento)"
                                    v-model="archivos.checked">
                                <span v-if="parametros.campos_obligatorios.antes_despues == 1 && archivos.cuando == ''"
                                    style="text-align: center;padding-left: 16%">
                                    <select v-model="archivos.cuando" id="tiempo">
                                        <option value="">Selecciona tiempo</option>
                                        <option value="Antes">Antes</option>
                                        <option value="Despues">Después</option>
                                    </select>
                                </span>
                                <span v-else style="text-align: center;padding-left: 16%">
                                    <span style="margin-right: 28%;" v-if="archivos.cuando == 'despues'"
                                        class="badge bg-blue">después</span>
                                    <span style="margin-right: 28%;" v-else class="badge bg-blue">{{ archivos.cuando
                                        }}</span>
                                </span>
                                <span style="font-size: x-small;padding-left: 20%;">{{archivos.fecha}}</span>
                                <!-- </div>-->
                                <!-- <div class="col-md-9">-->
                                <!--   <label v-if="archivos.documento.valueOf().length>15" :for="archivos.id_documento">
                                        {{ archivos.documento.substring(0,15)+'...' }} </label>-->
                                <label style="font-size: 12px;line-break: anywhere;  padding-right: 12px;"
                                    :for="archivos.id_documento">
                                    {{ archivos.documento}} </label>
                                <p></p>
                                <span v-if="archivos.descripcion" class="badge bg-secondary">{{ archivos.descripcion
                                    }}</span>

                                <!--  </div>-->
                            </div>

                        </div>

                    </div>
                    <p></p>
                    <p></p>
                    <h4 style="text-align:center">{{ $t('general.subirarchivos') }}</h4>
                    <FileUpload mode="advanced" ref="fileupdos" :showUploadButton="false" :maxFileSize="20000000"
                        @select="subirarchivo($event)" multiple="true" chooseLabel="Elegir Archivos" />
                    <p></p>
                    <p></p>
                    <div class="row">
                        <div class="col-md-12">
                            <textarea placeholder="Descripcion del fichero" v-model="descrfichero" rows="5"
                                class="form-control"></textarea>
                        </div>
                    </div>
                    <p></p>
                    <div class="row">
                        <div class="col-md-12">
                            <button
                                @click="uploadFile(visita.visita.operarios_idoperario, visita.visita.idvisitador,visita)"
                                class="btn btn-success btn-block" type="button">
                                {{$t('general.subirarchivos')}}
                            </button>
                        </div>
                    </div>
                </TabPanel>
            </TabView>
        </div>
    </div>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi'; 
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Image from 'primevue/image';
import FileUpload from 'primevue/fileupload';
import Dialog from 'primevue/dialog';

export default ({
    props: ['id','visitas','servicio'],
    data() {
        return {
            archivosasubir: [],
            archivo: '',
            descrfichero: '',
            archivosubido: [],
            documentosbasicos: [],   
            documentosservicio: [],
            documentoscomunicaciones: [],
            urlglobal:'',
            informes:[],
            mostrarForm:[],
            envioSeleccionado:[],
            emailIntroducido:[],
            destinoSeleccionado:[],
            text:[],
            parametros:[],
            check:[],
            tiempos:[],
            tiempoImagenSelect:[],
            papSeleccionado:[],
            ipasSeleccionado:[],
            mutuaSeleccionada:[],
            multiasistenciaSeleccionada:[],
            creandoInforme:false,
            numfotos:1,
            apaisado:false,
            logo:false,
            expediente:false,
            descripciones:false,
            tatexto:'',
            tadescripcion:'',
            informesasubir: [],
            mostrarVideo:false,
        }
    }, 
    setup() {
        return;
    },
    components: {
        TabPanel,TabView,Image,FileUpload,Dialog
    },
    methods: {
        async eliminararchivo(idarchivo) {
            const api = new PwgsApi();
            //let subidadatos = { accion: 'eliminar' };
            if (confirm('¿Desea eliminar el archivo?')) {

                try {
                    await api.put('servicios/' + this.$props.id + '/accion-archivo/' + idarchivo +'?accion=eliminar');
                    this.$parent.cargarvisitas();
                    this.$parent.$parent.cargardatos(this.$props.id, "cual", "si");
                    //this.$parent.$parent.cargarmasdatos();
                    console.log("parent", this.$parent);                // this.cargarInformes();
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });

                }
            }
        },
        async generarConsulta(visita){
            const api = new PwgsApi();
            var ids = {};
            try{
                if(visita){
                    for(var archivo of visita.archivos){
                        if(archivo.checked){
                            if(this.parametros.campos_obligatorios.antes_despues == 1 && archivo.cuando == ""){
                                alert('Las fotografías seleccionadas no tienen indicado el antes/después.')
                                return;
                            }
                            ids[archivo.id_documento] = archivo.cuando;
                        }
                    }
                    await api.post('servicios/'+this.id+'/informes-fotograficos', {ids_documentos:ids, texto:this.tatexto, descripcion:this.tadescripcion,
                        n_fotos_pag:this.numfotos, orientacion: this.apaisado? 'L':'P', logo:this.logo?1:0, expediente: this.expediente?1:0,
                        muestra_descripcion: this.descripciones?1:0});
                } else{
                    await api.post('servicios/'+this.id+'/informes-fotograficos', {ids_documentos:ids, texto:this.tatexto, descripcion:this.tadescripcion,
                        n_fotos_pag:this.numfotos, orientacion: this.apaisado? 'L':'P', logo:this.logo?1:0, expediente: this.expediente?1:0,
                        muestra_descripcion: this.descripciones?1:0});
                }
                this.cargarInformes();
            }catch(error){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 2000 });
            }
        },
        descargarArchivos(archivo){
            let auxurlpdf = archivo;
            window.open(auxurlpdf,'_blank')
        },
        descargar(link){
            var links = link.slice(5);
            let urlglobal = localStorage.getItem('direccion');
            window.open('https://'+urlglobal+links, '_blank');
        },
        reset(){
            this.archivosasubir = [];
            this.archivo= '';
            this.descrfichero= '';
            this.archivosubido= [];
            this.documentosbasicos= [] ;
            this.urlglobal= '';
            this.documentosServicio();
            if(this.documentosbasicos){
                for (let i = 0;i<this.documentosbasicos.length;i++){
                    this.documentosbasicos[i].checked = false;
                }
            }
            console.log("documentosbasicos", this.documentosbasicos);
        },
        async documentosServicio() {
            //GET  modulos/pwgsapi/index.php/servicios/:id/datos-basicos
            this.urlglobal = localStorage.getItem('direccion');
            // const api = new PwgsApi;
            //  let datos = await api.get('servicios/' + this.$props.id + '/datos-basicos');
            if(this.servicio.asegurado){
               this.documentosbasicos = this.$props.servicio.documentos.servicio;
            }
            this.documentosservicio= [] ;
            this.documentoscomunicaciones= [];
            for (let i = 0;i<this.documentosbasicos.length;i++){
                if(this.documentosbasicos[i].visitadores_idvisitador == 0 && this.documentosbasicos[i].mensajes_id_mensaje == 0){
                    this.documentosservicio.push(this.documentosbasicos[i]);
                }
                if(this.documentosbasicos[i].mensajes_id_mensaje > 0){
                    this.documentoscomunicaciones.push(this.documentosbasicos[i]);
                }
            }
        }, 
        async uploadFile(idoperario, idvisita,visita) {
            console.log("visita", visita);
            //POST  modulos/pwgsapi/index.php/servicios/:id/guardar-documento
            const formData = new FormData();
            if (idoperario>0 && idvisita>0){
            formData.append("id_operario", idoperario);
                formData.append("id_visita", idvisita);
            }
            else {
                formData.append("id_operario", 0);
                formData.append("id_visita", 0); this.mostrarplanning = true;
               /* this.cargardatos(this.$props.id);
                this.cargarmasdatos();
                this.obtenerEstadosPendientes();
                this.cargarEstadoPendiente();*/
            }
            formData.append("tipo_documento", 'ficherosvisitas');
            for (let i = 0; i < this.archivosubido.length; i++) {
                formData.append(this.archivosubido[i].name, this.archivosubido[i], this.archivosubido[i].name);
            }
            formData.append("descripcion", this.descrfichero);
            const api = new PwgsApi;
            try{
            await api.post('servicios/' + this.$props.id + '/guardar-documento', formData);  
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Archivo subido correctamente', life: 2000 });
                this.$parent.$parent.cargardatos(this.$props.id, "cual", "si");
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
            this.archivosubido = []; 
            this.$refs.fileupuno.clear();
            for (let i = 0;i<this.$refs.fileupdos.length;i++){
                this.$refs.fileupdos[i].clear();

            }
            this.$parent.cargarvisitas();
        },
        adjuntararchivo(archivo, checked, id) {
            console.log("checked", checked);
            let aux = 0;
            if (checked == true) {
                if (this.archivosasubir.length > 0) {
                    for (let i = 0; i < this.archivosasubir.length; i++) {
                      if (this.archivosasubir[i] == id) {
                            aux = 1;
                        }
                    }
                }
                if (aux < 1) {
                    this.archivosasubir.push(id);
                }
            }
            if (checked == false && this.archivosasubir) { 
                for (let i = 0; i < this.archivosasubir.length; i++) {
                    if (this.archivosasubir[i] == id) {
                        this.archivosasubir.splice(i, 1);
                    }
                }
            }
            this.$emit('archivoSeleccionado', this.archivosasubir);
        },
        adjuntarinforme(informe){
            if(informe.checked){
                this.informesasubir.push(informe);
            }else{
                let index = this.informesasubir.indexOf(informe);
                if (index > -1) {
                    this.informesasubir.splice(index, 1);
                }
            }
            this.$emit('informeSeleccionado', this.informesasubir);
        },
        subirarchivo(event) {
            for (let i = 0; i < event.files.length;i++){
            this.archivosubido.push(event.files[i]);
            }
        },
        async cargarInformes(){
            this.informes = [];
            this.activado = [];
            this.activadoV = [];
            const api = new PwgsApi();
            const resp = await api.get('servicios/'+this.id+'/informes-fotograficos');
            this.informes = resp.informes;
            this.parametros = resp.parametros;
            for(let inf of this.informes){
                var id = inf.id_documento;
                this.mostrarForm[id]=false;
                this.emailIntroducido[id]="";
                this.envioSeleccionado[id]="";
                this.destinoSeleccionado[id]="";
                this.papSeleccionado[id]="";
                this.ipasSeleccionado[id]="";
                this.mutuaSeleccionada[id]="";
                this.multiasistenciaSeleccionada[id]="";
                this.text[id]="";
                inf.checked=false;
            }
            this.informes.forEach(informe => informe.marcado = false);
        },
    },
    mounted() {
        this.documentosServicio();
        this.cargarInformes();
    },
    watch: {
        id() {  
            this.documentosServicio();
        },
        servicio(){
            this.documentosServicio();
        },


    }
})
</script>
<style>
.card-header::after{
    display: none;
}
.p-progressbar{
    height: 0;
}
</style>